import { render, staticRenderFns } from "./PatientMixWidget.vue?vue&type=template&id=2e622324&"
import script from "./PatientMixWidget.vue?vue&type=script&lang=js&"
export * from "./PatientMixWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports